<div [formGroup]="form" fxLayout="column">

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_TRANCE_MARKTLOKATION"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Marktlokation Tranche</mat-label>
      <input formControlName="marktlokation"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="marktlokation"
        [required]="hasAnyTrancheValue"
        matInput
        name="marktlokation_tranche"/>
      @if (f.marktlokation.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Marktlokation Tranche ein
        </mat-error>
      }
      @if (f.marktlokation.hasError('pattern')) {
        <mat-error>
          Länge 11, nur Zahlen, startet mit einer Zahl(1-9).
        </mat-error>
      }
      @if (f.marktlokation.hasError('checkDigit')) {
        <mat-error>
          Die Prüfsumme für die Marktlokation Tranche ist nicht korrekt.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_TRANCE_BILANZKREIS"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Bilanzkreis Tranche</mat-label>
      <input formControlName="bilanzkreis"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="bilanzkreis"
        [required]="hasAnyTrancheValue"
        matInput
        name="marktlokation_trancheBilanzkreis"/>
      @if (f.bilanzkreis.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Bilanzkreis Tranche ein
        </mat-error>
      }
      @if (f.bilanzkreis.getError('minlength'); as error) {
        <mat-error>
          EIC zu kurz ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.bilanzkreis.getError('maxlength'); as error) {
        <mat-error>
          EIC zu lang ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.bilanzkreis.getError('invalidCharacters'); as error) {
        <mat-error>
          EIC enthält ({{ error.amount }}) ungültige/s Zeichen: {{ error.characters }}
        </mat-error>
      }
      @if (f.bilanzkreis.hasError('checkCharInvalid')) {
        <mat-error>
          ID ungültig nach erfolgter Prüfzifferberechnung (Energy Identification Code)
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_TRANCE_LIEFERANT"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Lieferant Tranche</mat-label>
      <input formControlName="lieferant"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="lieferant"
        [required]="hasAnyTrancheValue"
        matInput
        name="marktlokation_trancheLieferant"/>
      @if (f.lieferant.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Lieferant Tranche ein
        </mat-error>
      }
      @if (f.lieferant.getError('pattern')) {
        <mat-error>
          Eine Lieferant Tranche besteht aus 13 Zeichen und startet mit einer Zahl zwischen 40 und 60 oder der 99.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_TRANCE_GROESSE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Tranchengröße [%]</mat-label>
      <input formControlName="groesse"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="groesse"
        [required]="hasAnyTrancheValue"
        matInput
        type="number"
        name="marktlokation_trancheGroesse"/>
      @if (f.groesse.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Tranchengröße [%] ein
        </mat-error>
      }
      @if (f.groesse.hasError('pattern') || f.groesse.hasError('max')) {
        <mat-error>
          0 bis 100 und < 100 max. 2 Nachkommastellen
        </mat-error>
      }
    </mat-form-field>
  </div>
</div>
